module.exports = __webpack_public_path__ + "img/logo-agec.848fc479.svg";